import JoinRoom from "../components/JoinRoom";

const JoinRoomPage = () => {
  return <JoinRoom />;
};

export default JoinRoomPage;
